import React, { Component } from 'react';
import moment from 'moment';
import { Table, Button, Label } from 'semantic-ui-react';
import ModalUser from './ModalUser';

class UserTableRow extends Component {
  render() {
    const { propsData } = this.props;
    const stat_new = <Label color='teal' horizontal>New</Label>;
    const stat_pending = <Label color='yellow' horizontal>Pending</Label>;
    const stat_failed = <Label color='red' horizontal>Failed</Label>;
    const stat_process = <Label color='blue' horizontal>Process</Label>;
    const stat_verified = <Label color='green' horizontal>Verified</Label>;

    return (
      <Table.Row>
        <Table.Cell>{propsData.fullName}</Table.Cell>
        <Table.Cell>{propsData.email}</Table.Cell>
        <Table.Cell>{propsData.phone}</Table.Cell>
        <Table.Cell>
          {propsData.groups.map( (data, i) => {
            let status = '';
            if (data.groupStatus === 'process') { status= stat_process }
            else if (data.groupStatus === 'pending') { status = stat_pending }
            else if (data.groupStatus === 'verified') { status = stat_verified }
            else if (data.groupStatus === 'failed') { status = stat_failed }
            else { status = stat_new }
            if (data.groupName === 'KTP' || data.groupName === 'Biometrik'){
              return (<span key={i}> {data.groupName}: {status} </span>)
            }else {
              return null
            }
          })}
        </Table.Cell>
        <Table.Cell>
          {
            propsData.firstSubmit
              ? moment(propsData.firstSubmit).format('DD MMMM YYYY')
              : '-'
          }
        </Table.Cell>
        <Table.Cell>
          {
            propsData.lastUpdated
              ? moment(propsData.lastUpdated).format('DD MMMM YYYY')
              : '-'
          }
        </Table.Cell>
        <Table.Cell>
          <ModalUser
            userId={propsData.userId}
            name={propsData.fullName}
            groups={propsData.groups}
            groupStatus={propsData.groupStatus}
            trigger={<Button color='olive' size='tiny'>VIEW</Button>}
          />
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default UserTableRow;


// WEBPACK FOOTER //
// ./src/app/component/Datauser/UserTableRow.js